import React, { Component } from "react";
import PropTypes from "prop-types";
import { CSSTransitionGroup } from 'react-transition-group';
import { connect } from "react-redux";

import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import 'webrtc-adapter';
import RecordRTC from 'recordrtc';

// register videojs-record plugin with this import
import 'videojs-record/dist/css/videojs.record.css';
import Record from 'videojs-record/dist/videojs.record.js';
import TsEBMLEngine from 'videojs-record/dist/plugins/videojs.record.ts-ebml.js';

class VideoRecord extends Component {
  constructor(props) {
    super(props);
    this.state = { };
    this.videoJsOptions = {
      controls: true,
      height: 440,
      fluid: false,
      plugins: {
        record: {
          audio: true,
          video: true,
          maxLength: 1800,
          debug: true,
          videoMimeType: 'video/webm;codecs=vp8,opus'
        }
      }
    };
  }


  componentDidMount() {
      this.player = videojs(this.videoNode, this.videoJsOptions, () => {
        var version_info = 'Using video.js ' + videojs.VERSION +
            ' with videojs-record ' + videojs.getPluginVersion('record') +
            ' and recordrtc ' + RecordRTC.version;
        videojs.log(version_info);
      });

      this.player.on('startRecord', () => {
        this.props.handleToggleRecording(true);
      });

      this.player.on('stopRecord', () => {
        this.props.handleToggleRecording(false);
      });

      this.player.on('finishRecord', () => {
        this.props.handleToggleRecording(false);
        console.log('finished recording: ', this.player.recordedData);
        this.props.handleFinishRecord(this.player.recordedData);
      })
      // this.player.on('finishConvert', () => {
      //     console.log('finished converting: ', this.player.convertedData);
      //     this.props.handleFinishRecord(this.player.convertedData);
      // });

    if (!this.props.isSafari) {
      this.player.record().getDevice()
    }

  }

  // destroy player on unmount
  componentWillUnmount() {
      if (this.player) {
          this.player.dispose();
      }
  }

  render() {
      return (
      <div data-vjs-player>
        <video
          id="RecordVideo"
          ref={node => this.videoNode = node}
          className="video-js vjs-default-skin"
          playsInline
        >
        </video>
      </div>
      );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  { }
)(VideoRecord);
